/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum HealthHistoryMedicinesEditAliases {
  ACTION_DELETE_HEALTH_HISTORY_MEDICINES = 'action-delete-health-history-medicines',
  ACTION_NEW_HEALTH_HISTORY_MEDICINES = 'action-new-health-history-medicines',
  ACTION_RELEASE_HEALTH_HISTORY_MEDICINES = 'action-release-health-history-medicines',
  AUTOCOMPLETE_CHANNEL_ADM = 'autocomplete-channel-adm',
  AUTOCOMPLETE_DATE_TYPE = 'autocomplete-date-type',
  AUTOCOMPLETE_INTERRUPT_REASON = 'autocomplete-interrupt-reason',
  AUTOCOMPLETE_INTERVAL = 'autocomplete-interval',
  AUTOCOMPLETE_JUSTIFICATION_FOR_END = 'autocomplete-justification-for-end',
  AUTOCOMPLETE_PROVENANCE = 'autocomplete-provenance',
  AUTOCOMPLETE_SECURITY_LEVEL = 'autocomplete-security-level',
  AUTOCOMPLETE_UNITY_MEASURE = 'autocomplete-unity-measure',
  CHECKBOX_DISPLAY_PATIENT_ALERTS = 'checkbox-display-patient-alerts',
  CHECKBOX_FIRST_TRIMESTER = 'checkbox-first-trimester',
  CHECKBOX_SECOND_TRIMESTER = 'checkbox-second-trimester',
  CHECKBOX_SELF_MEDICATION = 'checkbox-self-medication',
  CHECKBOX_THIRD_TRIMESTER = 'checkbox-third-trimester',
  CHECKBOX_UNKNOWN_END = 'checkbox-unknown-end',
  CHECKBOX_UNKNOWN_INFO_MEDICINE = 'checkbox-unknown-info-medicine',
  CHECKBOX_UNKNOWN_LAST_DOSE = 'checkbox-unknown-last-dose',
  CHECKBOX_UNKNOWN_START = 'checkbox-unknown-start',
  CONTEXTUAL_BAR_BODY = 'contextual-bar-body',
  DATE_FIELD_END_DATE = 'date-field-end-date',
  DATE_FIELD_LAST_DATE = 'date-field-last-date',
  DATE_FIELD_START_DATE = 'date-field-start-Date',
  FETCH_CHANNEL_ADM = 'fetch-channel-adm',
  FETCH_DATE_TYPE = 'fetch-date-type',
  FETCH_INTERRUPT_REASON = 'fetch-interrupt-reason',
  FETCH_INTERVAL = 'fetch-interval',
  FETCH_JUSTIFICATION_FOR_END = 'fetch-justification-for-end',
  FETCH_MATERIAL_MEDICINE = 'fetch-material-medicine',
  FETCH_PROVENANCE = 'fetch-provenance',
  FETCH_SECURITY_LEVEL = 'fetch-security-level',
  FETCH_UNITY_MEASURE = 'fetch-unity-measure',
  FIELD_CHANNEL_ADM = 'field-channel-adm',
  FIELD_CONDITION = 'field-condition',
  FIELD_DATE_TYPE = 'field-date-type',
  FIELD_DISPLAY_PATIENT_ALERTS = 'field-display-patient-alerts',
  FIELD_END_DATE = 'field-end-date',
  FIELD_FIRST_TRIMESTER = 'field-first-trimester',
  FIELD_INTERRUPT_REASON = 'field-interrupt-reason',
  FIELD_INTERVAL = 'field-interval',
  FIELD_JUSTIFICATION_FOR_END = 'field-justification-for-end',
  FIELD_LAST_DATE = 'field-last-date',
  FIELD_MATERIAL_MEDICINE = 'field-material-medicine',
  FIELD_OBSERVATION = 'field-observation',
  FIELD_PROVENANCE = 'field-provenance',
  FIELD_QT_DOSE = 'field-qt-dose',
  FIELD_REACTION = 'field-reaction',
  FIELD_SCHEDULES = 'field-schedules',
  FIELD_SECOND_TRIMESTER = 'field-second-trimester',
  FIELD_SECURITY_LEVEL = 'field-security-level',
  FIELD_SELF_MEDICATION = 'field-self-medication',
  FIELD_START_DATE = 'field-startDate',
  FIELD_START_MONTH = 'field-start-month',
  FIELD_START_YEAR = 'field-start-year',
  FIELD_THIRD_TRIMESTER = 'field-third-trimester',
  FIELD_UNIT_MEASURE = 'field-unit-measure',
  FIELD_UNKNOWN_END = 'field-unknown-end',
  FIELD_UNKNOWN_INFO_MEDICINE = 'field-unknown-info-medicine',
  FIELD_UNKNOWN_LAST_DOSE = 'field-unknown-last-dose',
  FIELD_UNKNOWN_START = 'field-unknown-start',
  FIELD_UNREGISTRED_MEDICINE = 'field-unregistred-medicine',
  FORM_ONE = 'form-one',
  FORM_THREE = 'form-three',
  FORM_TWO = 'form-two',
  INFORMATION_BAR_HEADER_FRAGMENT = 'information-bar-header-fragment',
  INPUT_MEDICINE = 'input-medicine',
  INPUT_QT_DOSE = 'input-qt-dose',
  INPUT_SCHEDULES = 'input-schedules',
  INPUT_START_MONTH = 'input-start-month',
  INPUT_START_YEAR = 'input-start-year',
  INPUT_UNREGISTRED_MEDICINE = 'input-unregistred-medicine',
  LAYOUT_HEALTH_HISTORY_MEDICINES = 'layout-health-history-medicines',
  LOCATOR_FIELD_MEDICINE = 'locator-field-medicine',
  LOCATOR_MEDICINE = 'locator-medicine',
  MAPPER_CHANNEL_ADM = 'mapper-channel-adm',
  MAPPER_DATE_TYPE = 'mapper-date-type',
  MAPPER_INTERRUPT_REASON = 'mapper-interrupt-reason',
  MAPPER_INTERVAL = 'mapper-interval',
  MAPPER_JUSTIFICATION_FOR_END = 'mapper-justification-for-end',
  MAPPER_PROVENANCE = 'mapper-provenance',
  MAPPER_SECURITY_LEVEL = 'mapper-security-level',
  MAPPER_UNITY_MEASURE = 'mapper-unity-measure',
  PANEL_BODY = 'panel-body',
  PANEL_HEADER = 'panel-header',
  RADIO_GROUP_CONDITION = 'radio-group-condition',
  TEXT_AREA_OBSERVATION = 'text-area-observation',
  TEXT_AREA_REACTION = 'text-area-reaction',
  TEXT_CHANNEL_ADM = 'text-channel-adm',
  TEXT_DATE_TYPE = 'text-date-type',
  TEXT_INTERRUPT_REASON = 'text-interrupt-reason',
  TEXT_INTERVAL = 'text-interval',
  TEXT_JUSTIFICATION_FOR_END = 'text-justification-for-end',
  TEXT_PROVENANCE = 'text-provenance',
  TEXT_SECURITY_LEVEL = 'text-security-level',
  TEXT_UNITY_MEASURE = 'text-unity-measure',
  WIZARD = 'wizard',
  WIZARD_STEP_ONE = 'wizard-step-one',
  WIZARD_STEP_THREE = 'wizard-step-three',
  WIZARD_STEP_TWO = 'wizard-step-two',
}
export { HealthHistoryMedicinesEditAliases };
